import { Update } from "@ngrx/entity";
import { createAction, props } from "@ngrx/store";
import { serverAccountInfoModel } from "../models/serverResponse.model";

export const loadUserInformation = createAction(
    "[Account] Load User Information"
)

export const updateUserInformation = createAction(
    "[Account] User Information Loaded",
    props<{userInfo:Update<serverAccountInfoModel>}>()
)

export const UserInformationLoaded = createAction(
    "[Account] User Information Loaded",
    props<{userInfo:serverAccountInfoModel}>()
)

export const UserInformationUnreachable = createAction(
    "[Account] User Information Unreachable"
)